import { AUS_DOMAIN, NZ_DOMAIN } from '../shared/constants';

const {
  REACT_APP_DASH_ROOT,
  REACT_APP_DASH_ROOT_AUS,
  REACT_APP_DASH_ROOT_NZ,
} = process.env;

export const determineDashRoot = () => {
  const { hostname } = window.location;
  if (hostname.endsWith('.' + NZ_DOMAIN)) {
    return REACT_APP_DASH_ROOT_NZ;
  }
  if (hostname.endsWith('.' + AUS_DOMAIN)) {
    return REACT_APP_DASH_ROOT_AUS;
  }
  return REACT_APP_DASH_ROOT;
};
